<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",

});
</script>

<style>
:root {
  --primary-color: #BA7BA1;
  --primary-color-dark: #a66d8e;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  font-weight: 100;
  color: #333;
  line-height: 1.6;
  background-color: #f7f7f7;
}

/* Global styles that might be needed across components */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

.btn {
  display: inline-block;
  padding: 0.75em 1.5em;
  border: 2px solid black;
  background-color: white;
  color: black;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.25s ease, color 0.25s ease;
  min-width: 150px;
}

.btn:hover,
.btn:focus {
  outline: none;
  transform: translateY(-2px);
}

.btn:active {
  transform: scale(0.98);
}

/* Smooth scrolling for the entire app */
html {
  scroll-behavior: smooth;
}

/* Basic responsive design */
@media (max-width: 768px) {
  .container {
    width: 95%;
    padding: 0 10px;
  }
}
</style>


